export enum MerlinxFlightTypes {
  AIRPORT = 'airport',
  AIRPORT_GROUP = 'airportGroup'
}
